import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.tickets || initialState;

export const selectTickets = createSelector(
  [selectDomain],
  ticketsState => ticketsState,
);
